import * as React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { filter } from 'lodash';
import routes from 'helpers/routes';
import { CaseStudyType } from 'types';
import { theme, media } from 'styles';
import { Breadcrumbs, Container, Button, SeoTags } from 'components/shared';
import { List } from './components';

const Wrapper = styled.div`
  background-color: ${theme.colors.offWhite};
  padding-bottom: 36px;

  ${media.laptop`
    padding-bottom: 96px;
  `};
`;

const HeroContainer = styled(Container)`
  height: 100%;

  ${media.tablet`
    display: flex;
  `};
`;

const Hero = styled.div`
  margin-bottom: ${theme.sp.max};
  background-color: ${theme.colors.white};

  ${media.tablet`
    margin-bottom: 150px;
    height: 600px;
  `};

  h2 {
    font-size: 48px;
    line-height: 44px;
    font-weight: 700;
    margin: 0 0 40px;
    color: ${theme.colors.royal};
    max-width: 600px;

    ${media.tablet`
      font-size: 64px;
      line-height: 60px;
      margin: 0 0 40px;
    `};
  }

  h4 {
    margin: 30px 0 10px;
    font-size: 18px;
    line-height: 23px;
    color: ${theme.colors.grey};

    ${media.tablet`
      margin: 40px 0 34px;
    `};
  }
`;

const HeroContent = styled.div`
  padding-top: ${theme.sp.l};
  position: relative;
  width: 100%;

  ${media.tablet`
    padding-top: ${theme.sp.max};
    width: 50%;
  `};
`;

const HeroImage = styled.div`
  width: 100%;

  ${media.tablet`
    width: 50%;
  `};

  img {
    display: block;
    position: relative;
    max-width: 100%;
    height: auto;
    margin: 0 auto;
    bottom: -50px;

    ${media.tablet`
      max-width: none;
      bottom: -100px;
  `};
  }
`;

const HeroButton = styled(Button)`
  padding: 0 24px;
  height: 44px;
  font-size: 14px;

  ${media.tablet`
    padding: 0 30px;
    height: 50px;
    font-size: 16px;
  `};
`;

const Main = styled(Container)`
  display: flex;
  flex-direction: column;

  ${media.desktop`
    flex-direction: row;
  `};
`;

const propTypes = {
  caseStudies: PropTypes.arrayOf(CaseStudyType).isRequired,
};

class CaseStudiesPage extends React.Component {
  getBreadcrumbs = () => {
    const initial = [
      {
        name: 'Home',
        link: `${routes.home.index}`,
      },
      {
        name: 'Work',
        link: `${routes.caseStudy.index}`,
      },
    ];

    return initial;
  };

  render() {
    const breadcrumbs = this.getBreadcrumbs();
    const featuredStudy = filter(
      this.props.caseStudies,
      study => study.featured,
    )[0];
    const studies = filter(
      this.props.caseStudies,
      study => study !== featuredStudy,
    );
    return (
      <Wrapper>
        <SeoTags
          title="Our Work & Client Success | MarketTap"
          description="At MarketTap, we place a huge emphasis on creating great work that makes a big impact. Check out some of our work here to see how we've helped businesses meet and exceed their goals."
        />

        <Hero>
          <HeroContainer>
            <HeroContent>
              <Breadcrumbs left breadcrumbs={breadcrumbs} />
              <h4>{featuredStudy.heading}</h4>
              <h2>{featuredStudy.subHeading}</h2>
              <HeroButton blue to={`/work/${featuredStudy.slug}`}>
                View Case Study
              </HeroButton>
            </HeroContent>
            <HeroImage>
              <img
                src={
                  featuredStudy.headerBackgroundImage.responsiveResolution.src
                }
                alt={featuredStudy.heading}
              />
            </HeroImage>
          </HeroContainer>
        </Hero>

        <Main>
          <List caseStudies={studies} />
        </Main>
      </Wrapper>
    );
  }
}

CaseStudiesPage.propTypes = propTypes;

export default CaseStudiesPage;



// WEBPACK FOOTER //
// ./src/components/CaseStudiesPage/CaseStudiesPage.jsx